
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'FlowHtmlDescription',
})
export default class FlowHtmlDescription extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  schema: any;

  @Prop({
    type: Object,
    required: true,
  })
  data: any;

  @Prop({
    type: String,
    required: true,
  })
  value: string;

  tinyMceConfig = {
    autostart: true,
    statusbar: true,
    menubar: false,
    // spellcheck
    plugins: ['code'],
    toolbar1: 'styleselect | bold italic | bullist numlist | code', // | spellcheck
    toolbar2: null,
    height: 300,
  };
}
